import { MailRegular, MailErrorRegular } from '@fluentui/react-icons';
import { IconProps } from './StyledIconProps';
import StyledIcon from './StyledIcon';

const MailIcon: React.FC<IconProps> = ({
    interactive = false,
    width = 20,
    height = 20,
    type = 'success',
    className,
}) => {
    return (
        <StyledIcon
            interactive={interactive}
            width={width}
            height={height}
            type={type}
            className={className}
            successIcon={<MailRegular />}
            dangerIcon={<MailErrorRegular />}
        />
    );
};

export default MailIcon;
